import { JSX, useCallback } from "react";
import { useTranslation } from "react-i18next";

import ConfirmationDialog from "lib/components/dialog/ConfirmationDialog";

export type DeleteRoleDialogProps = {
	roleIndex: number;
	roleName: string;

	onConfirm: (index: number) => void;
	onCancel: () => void;
};

export default function DeleteRoleDialog(
	props: Readonly<DeleteRoleDialogProps>
): JSX.Element {
	const { t } = useTranslation();

	const handleConfirm = useCallback((): Promise<void> => {
		props.onConfirm(props.roleIndex);
		return Promise.resolve();
	}, [props.onConfirm, props.roleIndex]);

	return (
		<ConfirmationDialog
			title={t("deleteDocumentTitle", { document: "role" })}
			dialogText={t("deleteRoleMessage", { roleName: props.roleName })}
			cancelLabel={t("cancel")}
			confirmLabel={t("delete")}
			onClose={props.onCancel}
			onConfirm={handleConfirm}
		/>
	);
}
